import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Input } from '../../../../components/ModalInputs'
import { OrderContext } from '../../../../utils/context'
import moment from 'moment'
import { getCourses } from '../../../../actions/common'
import Button from '../../../../components/Button'
import EnrollModal from '../EnrollModal/EnrollModal'
import Table from '../../../../components/Table'


export default function Departure() {

  const dispatch = useDispatch()

  const { values, personnelList, setFieldValue, handleChange, specFields, setValues } = useContext(OrderContext)
  const { list } = useSelector(state => state.students)
  const { studentList } = list || {}

  const [openEnrollModal, setOpenEnrollModal] = useState(false)
  const [selectedStudents, setSelectedStudents] = useState([])

  useEffect(() => {
    !list && dispatch(getCourses())
    const profilesIn = values.profiles && values.profiles.map(el => list.find(item => item.mid == el))
    profilesIn && setSelectedStudents(profilesIn)
  }, [list])

  useEffect(() => {
    const onlyId = selectedStudents && selectedStudents.map(el => el.mid)
    !!selectedStudents && setValues({ ...values, profiles: onlyId })
  }, [selectedStudents])

  const openEnroll = () => {
    setOpenEnrollModal(true)
  }
  const closeEnroll = () => {
    setOpenEnrollModal(false)
  }

  const handleChangeStudents = (student) => {
    if (typeof student === 'number') setSelectedStudents((prev) => prev.filter(el => el.mid !== student))
    else setSelectedStudents((prev) => !prev.find(el => el.mid === student.mid) ? [...prev, student] : prev.toSpliced(prev.indexOf(student), 1))
  }
  const renderLi = (data) => {
    const { fio } = data
    return (
      <tr>
        <td>{fio}</td>
      </tr>
    )
  }
  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            {openEnrollModal &&
              <EnrollModal
                closeModal={closeEnroll}
                data={openEnrollModal}
                height={'430px'}
                handleChangeStudents={handleChangeStudents}
                selectedStudents={selectedStudents}
              />
            }
            <Button mode='white' onClick={openEnroll}>Добавить ученика</Button>
            {selectedStudents.length > 0 &&
              <Table className={styles.tables}>
                <thead>
                  <tr>
                    <th>ФИО</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedStudents.map(renderLi)}
                </tbody>
              </Table>}
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Дата убытия'
              name='date'
              value={moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Куда'
              name='string'
              value={values.string}
              // error={error('string2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Checkbox
              name='logical'
              label='На лечении'
              checked={values.logical}
              onChange={() => setFieldValue('logical', Number(!values.logical))}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='С продовольственного обеспечения снять'
              name='date2'
              value={moment(values.date2).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Основание'
              name='string2'
              value={values.string2}
              // error={error('string2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
        </div>
      </div >

    </>
  )
}
